import { Table } from "@/features/Table";
import {
  type G4SustainAnalytics,
  g4_sustainanalytics_columns,
} from "./columns";
import {
  type FilterG4SustainAnalyticsSchema,
  FilterG4Sustainanalytics,
} from "./filter";
import { Tables } from "../../../gen/tableNames/tables";
import { Clients } from "../../../lib/clients";

export const G4MSustainanalyticsTable = () => {
  return (
    <Table<G4SustainAnalytics, FilterG4SustainAnalyticsSchema>
      label="Sustain analytics"
      client={Clients.G4}
      table_name={Tables.G4_SUSTAINALYTICS_ESG}
      columns={g4_sustainanalytics_columns}
      filter={<FilterG4Sustainanalytics />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.G4}/${Tables.G4_SUSTAINALYTICS_ESG}/new`,
        },
      ]}
    />
  );
};
